// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"4":"snpkit-icons-all-paths","552":"snpkit-icons-all-paths-loader"}[chunkId] || chunkId) + "." + {"4":"4ce98cc1","552":"4a125ded","790":"d6e32599"}[chunkId] + ".chunk.js";
};